import { ChangeViewButton } from './ChangeViewButton'

export const ChangeView = ({ viewOption, handleViewChange }) => (
  <div className="change-view">
    <ChangeViewButton
      active={viewOption === 'list'}
      onClick={() => handleViewChange('list')}
    >
      <i className="far fa-bars" />
    </ChangeViewButton>

    <ChangeViewButton
      active={viewOption === 'grid'}
      onClick={() => handleViewChange('grid')}
    >
      <i className="far fa-border-all" />
    </ChangeViewButton>
  </div>
)
